var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"hf-loading"},[_c('icon',{style:({'transform': 'rotateZ(' + _vm.deg + 'deg)'}),attrs:{"name":"loading","scale":3.9}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }